class InvitationResponse {
    constructor() {
        this.success = false;
        this.message = '';
        
    }
    static fromApiResponse(response) {
        return {
          success: response.success !== undefined ? response.success : false,
          message: response.message || ''
        };
      }
    
}
export default InvitationResponse;